import { render, staticRenderFns } from "./orSeperator.vue?vue&type=template&id=6b887a34&scoped=true"
import script from "./orSeperator.vue?vue&type=script&setup=true&lang=js"
export * from "./orSeperator.vue?vue&type=script&setup=true&lang=js"
import style0 from "./orSeperator.vue?vue&type=style&index=0&id=6b887a34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b887a34",
  null
  
)

export default component.exports